import { Component, OnDestroy, OnInit, ChangeDetectorRef, Renderer2, AfterViewInit } from '@angular/core';
import { SocoHttpService } from '@app/base/soco';
import { GasRequestStatusViewModel, LandingService } from '@app/modules/landing/base';
import { TrackerStepsStatusViewModel } from '@app/modules/landing/base';
import { ConstantsService, SessionService } from '@app/base/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { KMIUpdate } from '../../base/models/KMIUpdate.model';
import { ContactUsService } from '@app/shared/services/contact-us.service';
declare var swal: any;

@Component({
    selector: 'app-service-tracker',
    templateUrl: './service-tracker.component.html',
    styleUrls: ['./service-tracker.component.scss']
})
export class ServiceTrackerComponent implements OnInit, AfterViewInit, OnDestroy {

    public projectAddress: string = '';
    public serviceTrackerData: GasRequestStatusViewModel | null = null;
    public currentIndex = 0;
    public stepSize = 5;
    public id: number;
    public allStepsData: TrackerStepsStatusViewModel[] = [];
    public initialStepsData: TrackerStepsStatusViewModel[] = [];
    public displayedSteps: TrackerStepsStatusViewModel[] = [];
    public steps: string[] = [];
    public showInitialSteps = true;
    public onHoldStatus: string;
    showAllSteps: boolean = true;
    showLegends: boolean = false;
    latestWIPIndex: number;
    ServiceWRstatus: string;
    IsAllServicerequest: string;
    startIndex: number = 0;
    startIndexNum: number = 0;
    displayCount: number = 5;
    percentage: number = 0;
    progress: number = 0;
    diameter = 60;
    strokeWidth = 9;
    displayPercentage: boolean = false;
    imageMapping: { [key: string]: string } = {
        'APPLICATION RECEIVED': '/assets/images/step_images/Application_Received.png',
        'MARKETER SELECTED': '/assets/images/step_images/Marketer_Selected.png',
        'PROJECT ASSIGNED': '/assets/images/step_images/Project_Assigned.png',
        'PROJECT INFORMATION': '/assets/images/step_images/Project_Information.png',
        'ENGINEERING REVIEW': '/assets/images/step_images/Engineering_Review.png',
        'CONTRACT SENT': '/assets/images/step_images/Contract_Execution.png',
        'CONTRACT EXECUTION': '/assets/images/step_images/Contract_Execution.png',
        'CONSTRUCTION PAYMENT': '/assets/images/step_images/Construction_Payment.png',
        'SITE READY': '/assets/images/step_images/Site_Ready.png',
        'SERVICE INSTALLATION': '/assets/images/step_images/Service_Meter_Installation.png',
        'FUEL LINE INSPECTION': '/assets/images/step_images/Fuel_Line_Inspection.png',
        'METER INSTALLATION': '/assets/images/step_images/Service_Meter_Installation.png',
        'EASEMENT REQUIRED': '/assets/images/step_images/Easement_Required.png',
        'RIGHT-OF-WAY PERMITTING': '/assets/images/step_images/Right-of-Way_Permitting.png',
        'SERVICE AND METER INSTALLATION': '/assets/images/step_images/Service_Meter_Installation.png',
        'MAIN': '/assets/images/step_images/Main.png'
    };
    projectStartDate: Date;
    projectCompletionSle: number;
    projectEndDate: Date;
    holidays: any[] = [];
    builderHomeActive: boolean = false;
    isBannerVisible = true;
    feedbackForm: FormGroup;
    kmiForm: FormGroup;
    kmiSearchForm: FormGroup;
    feedbackAlreadyGiven = false;
    skippedStepGiven = 0;
    feedbackIdGiven = 0;
    feedbackTextGiven: string = null;
    currentRating = 1;
    public bcaId: number;
    rating: number = 0;
    approach: string = "";
    stepSkippedAt: number;
    ExKMITransactionStatus: string;
    filterProjectLength: number;
    nodata: number;
    blankdata: number;
    //find: number;
    form: FormGroup;
    public modelKMIUpdate: KMIUpdate;
    kmidata: any[] = [];
    contactUsData: FormGroup;
    task2540Status: string;

    task2535Status: string;

    ExKMIPrefrance: string;
    ExKMIEmail: string;
    ExKMIPhone : string;
    ExKMIFrequency : string;
    kMIConfigurationData: any[] = [];
    constructor(
        public constantsSvc: ConstantsService,
        private landingSvc: LandingService,
        private socoHttp: SocoHttpService,
        public sessionSvc: SessionService,
        private detectChange: ChangeDetectorRef,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private contactUs: ContactUsService,
        private renderer: Renderer2
    ) {       
        document.getElementById('glance-header-logo').hidden = true;
    }

    ngOnInit() {
        const serviceData = localStorage.getItem('serviceTrackerData');
        const holidayList = localStorage.getItem('holidaysData');
        if (holidayList) {
            this.holidays = JSON.parse(holidayList);
        } else {
            console.error('holidayList not found in local storage');
        }
        if (serviceData) {
            this.serviceTrackerData = JSON.parse(serviceData);
            this.id = this.serviceTrackerData.requestId;
            this.bcaId = this.serviceTrackerData.bcaId;
            this.onHoldStatus = this.serviceTrackerData.onHold;
            this.projectAddress = this.serviceTrackerData.serviceFormattedAddress;
            this.projectStartDate = new Date(this.serviceTrackerData.requestDate);
            this.projectCompletionSle = Number(this.serviceTrackerData.projectCompletionSle);
            this.projectEndDate = this.lastWorkingDaysCalculator(this.projectStartDate, this.projectCompletionSle);
            this.approach = this.serviceTrackerData.approach;
            this.ServiceWRstatus = this.serviceTrackerData.serviceWRStatus;
            this.IsAllServicerequest = this.serviceTrackerData.isAllServiceRequest;

            this.task2540Status = this.serviceTrackerData.task2540Status;
            this.task2535Status = this.serviceTrackerData.task2535Status;
            this.trackerStepsallStepsData();
            this.buildFeedbackFormGroup();
            this.buildKMIFormGroup();
            this.buildKMISearchFormGroup();
        } else {
            console.error('bcaSearch data not found in local storage');
        }

        this.route.queryParams.subscribe(params => {
            this.builderHomeActive = params['fromBuilder'] === 'true';
        });

        this.contactUsData = this.fb.group({
            ApplicantFullName: new FormControl('', [Validators.required, Validators.maxLength(200)]),
            EmailAddress: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.emailPattern), Validators.maxLength(150)]),
            Message: new FormControl('', [Validators.required, Validators.maxLength(500)]),
            ApplicantId: new FormControl(''),
            BcaId: new FormControl('')
        });
        this.LoadKMIConfigurations();
    }

    ngAfterViewInit() {
        this.disableTextAndBothOtions();
    }
    get currentStages() {
        if (this.showAllSteps) {
            return this.allStepsData;
        } else {
            return this.displayedSteps;
        }
    }
    getKMIDataByProjectId() {
       
        if (!this.kmiSearchForm.valid) {
            this.blankdata = 1;
            return;
        }
        this.landingSvc.getKMIDataByProjectId(this.id).subscribe(result => {
            if (result.data != null) {
                
                const formValue = this.kmiSearchForm.value;
                formValue.BcaId = this.bcaId;
                formValue.GrId = this.id;                              
                formValue.KMISearchEmailAddress = this.kmiSearchForm.controls['KMISearchEmailAddress'].value;
                formValue.KMISearchPhone = this.kmiSearchForm.controls['KMISearchPhone'].value;                
                if (formValue.KMISearchEmailAddress != null && formValue.KMISearchEmailAddress != "" && formValue.KMISearchPhone != null && formValue.KMISearchPhone != "") {
                    
                    if (result.data[0].kmiEmail == formValue.KMISearchEmailAddress && result.data[0].kmiPhone.replace(/[^a-zA-Z0-9]/g, "") == formValue.KMISearchPhone.replace(/[^a-zA-Z0-9]/g, "")) {
                        this.filterProjectLength = 1;
                        this.nodata = 0;
                        this.blankdata = 0;
                        
                        this.buildKMIFormGroup();
                        this.bindkmidata();

                    }
                    else {
                        this.filterProjectLength = 0;
                        this.nodata = 1;
                        this.blankdata = 0;
                       
                    }
                }
                else if (formValue.KMISearchEmailAddress != null && formValue.KMISearchEmailAddress != "") {
                    if (result.data[0].kmiEmail == formValue.KMISearchEmailAddress) {
                        this.filterProjectLength = 1;
                        this.nodata = 0;
                        this.blankdata = 0;
                        
                        this.buildKMIFormGroup();
                       
                        this.bindkmidata();

                    }
                    else {
                        this.filterProjectLength = 0;
                        this.blankdata = 0;
                        this.nodata = 1;
                       

                    }
                }
                else if (formValue.KMISearchPhone != null && formValue.KMISearchPhone != "") {                    
                    if (result.data[0].kmiPhone.replace(/[^a-zA-Z0-9]/g, "") == formValue.KMISearchPhone.replace(/[^a-zA-Z0-9]/g, "")){                    
                        this.filterProjectLength = 1;
                        this.nodata = 0;
                        this.blankdata = 0;
                        this.buildKMIFormGroup();
                        this.bindkmidata();
                    }
                    else {
                        this.filterProjectLength = 0;
                        this.blankdata = 0;
                       
                        this.nodata = 1;
                    }
                }
                
            }
        });
       // this.disableTextAndBothOtions();
    }

    LoadKMIConfigurations(){
        this.landingSvc.GetKMITransactionStatusData("KMI_Transaction").subscribe(result => {
            this.kMIConfigurationData=result.data;
        });
    }  
    
    FindKMITransactionActionCode(emailAction?: string, textAction?: string) {
     
        if(this.kMIConfigurationData.length>0){            
            var actionCode= this.kMIConfigurationData.filter(item => item.valuE2 === emailAction && item.valuE3 === textAction);
            return actionCode[0].valuE1;
        }
    }


    SubmitKMIForm() {        
        const formValue = this.kmiForm.value;
        formValue.id = this.id;
        formValue.GrId = this.id;
        formValue.BcaId = this.bcaId;
        formValue.kmiCommunication = this.kmiForm.controls['kmiCommunication'].value;
        formValue.KMIPreference = this.kmiForm.controls['kmiReceive'].value;
        formValue.KMIEmail = this.kmiForm.controls['kmiEmailAddress'].value;
        formValue.KMIPhoneNo = this.kmiForm.controls['kmiTextNumber'].value;
        formValue.kmiFrequency = this.kmiForm.controls['kmiFrequency'].value;
               
        //Conditation to update Flag/TransactionStatus for IRP Services
        if (this.ExKMITransactionStatus == "No" && formValue.kmiCommunication == "Yes" && formValue.KMIPreference == "Both" ) {
            //if new preference is both // Email Insert after Re-Opt-In and Text Insert after Re-Opt-In            
            //formValue.KMITransactionStatus = "EUITUI";
            formValue.KMITransactionStatus = this.FindKMITransactionActionCode('UI','UI');
        }
        else if (this.ExKMITransactionStatus == "No" && formValue.kmiCommunication == "Yes" && formValue.KMIPreference == "Email") {
            //if new preference is email // Email Update after Re-Opt-In and Text NULL after Re-Opt-In
            //formValue.KMITransactionStatus = "EUITN";
            formValue.KMITransactionStatus = this.FindKMITransactionActionCode('UI', '');
        }
        else if (this.ExKMITransactionStatus == "No" && formValue.kmiCommunication == "Yes" && formValue.KMIPreference == "Text") {
            //if new preference is text // Email Null after Re-Opt-In and Text Insert after Re-Opt-In **
           // formValue.KMITransactionStatus = "ENTUI";
            formValue.KMITransactionStatus = this.FindKMITransactionActionCode('', 'UI');
        }
        else if (this.ExKMITransactionStatus == "Yes" && formValue.kmiCommunication == "No") {
            //if user Opt-Out//Email Delete and Text Delete
            //formValue.KMITransactionStatus = "EDTD";
            formValue.KMITransactionStatus = this.FindKMITransactionActionCode('D', 'D');
        }
        else if (this.ExKMITransactionStatus == "Yes" && formValue.kmiCommunication == "Yes"
            && formValue.KMIPreference == "Both"
            && (this.ExKMIEmail != formValue.KMIEmail || this.ExKMIPhone != formValue.KMIPhoneNo)) {
            //Email Update and Text Update with Preference as both
           //formValue.KMITransactionStatus = "EUTU";
            formValue.KMITransactionStatus = this.FindKMITransactionActionCode('U', 'U');
        }
        else if (this.ExKMITransactionStatus == "Yes" && formValue.kmiCommunication == "Yes" && formValue.KMIPreference == "Email"
            && (this.ExKMIPrefrance == "Both" || this.ExKMIPrefrance == "Text" || this.ExKMIPrefrance == "Email")) {
            //Email Update and Text Delete // if Preference change to only email 
            //formValue.KMITransactionStatus = "EUTD";
            formValue.KMITransactionStatus = this.FindKMITransactionActionCode('U', 'D');
        }
        else if (this.ExKMITransactionStatus == "Yes" && formValue.kmiCommunication == "Yes" && formValue.KMIPreference == "Text"
            && (this.ExKMIPrefrance == "Both" || this.ExKMIPrefrance == "Email" || this.ExKMIPrefrance == "Text")) {
            //Email Update and Text Add as new prefrance // if Preference change to only text 
            //formValue.KMITransactionStatus = "EUTU";
            formValue.KMITransactionStatus = this.FindKMITransactionActionCode('U', 'U');
        }
        else if (this.ExKMIFrequency != formValue.kmiFrequency) {
            // If Frequency alone changes then we update both email text with same value, because along with these contact only Frequency can be passed as an Attribute
            formValue.KMITransactionStatus = this.FindKMITransactionActionCode('U', 'U');
        }
        else {
            formValue.KMITransactionStatus = null;
        }
        this.landingSvc.PutKMIData(formValue).subscribe(result => {
        }, result => { swal(this.constantsSvc.errorSwal1, this.constantsSvc.contactCustomerCareSwal, this.constantsSvc.errorSwal); });
        $('#KMI_Update_modal').modal('hide');
        if (this.ExKMITransactionStatus == "No" && formValue.kmiCommunication == "Yes")
            $('#service_tracker_KMI_confirmation_modal').modal('show');
        else
            $('#service_tracker_KMI_confirmation_modal').modal('hide');
    }

    calculatePercentage() {
        let allStepsCount: number = this.allStepsData.length;
        if (allStepsCount > 0) {
            this.displayPercentage = true;
            let completedSteps = this.allStepsData.filter(task => task.taskStatusCode === 'C');
            let completedStepsCount: number = completedSteps.length;
            // Calculate percentage
            this.percentage = completedStepsCount * 100.0 / allStepsCount;
            // Round the percentage to the nearest integer
            this.progress = Math.round(this.percentage);
        }
    }

    trackerStepsallStepsData() {
        this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
        this.landingSvc.getGasApproachById(this.id).subscribe(result => {
            this.allStepsData = this.addImageUrlsToData(result.data.filter(task => {
                // Display MARKETER SELECTED step only for state GA
                if (task.state !== 'GA' && task.trackerSteps === 'MARKETER SELECTED') {
                    return false;
                }

                if (task.taskStatusCode === 'WR NOT CREATED' && (task.trackerSteps === 'SITE READY' || task.trackerSteps === 'SERVICE INSTALLATION')
                    && this.task2540Status === 'B' && task.approachType !== 'BUILDER SET APPROACH') {
                    return false;
                }
                if (task.trackerSteps === 'MAIN' && this.task2535Status === 'B' && task.approachType === 'BUILDER SET APPROACH') {
                    return false;
                }
                return task.taskStatusCode !== 'B' && task.taskStatusCode !== 'TASK NOT PRESENT';
            }));
            // Filter out only the "Work in Progress" steps
            const wipSteps = this.allStepsData.filter(step => step.taskStatusCode === "W");
            if (wipSteps.length > 0) {
                // Sort the "Work in Progress" steps by date (descending)
                wipSteps.sort((a, b) => {
                    const dateA = new Date(a.dateModified).getTime();
                    const dateB = new Date(b.dateModified).getTime();
                    return dateB - dateA;
                });
                // Get the latest "Work in Progress" step
                const latestWIPStep = wipSteps[0];
                this.latestWIPIndex = this.allStepsData.findIndex(step => step === latestWIPStep);
                this.initialDisplayedSteps();
            } else {
                // If no WIP steps, display the first 5 steps
                this.displayedSteps = this.allStepsData.slice(0, 5);
                this.initialStepsData = this.displayedSteps;
                this.showAllSteps = false;
                this.showLegends = true;
                this.calculatePercentage();
            }
            // CXCO-1159-Show Popup based on Condition - any 5 or 7 steps completed and no feedback exisits in table for the Project
            this.getFeedbackByProjectId(this.allStepsData);
        });
    }

    initialDisplayedSteps() {
        if (this.latestWIPIndex !== -1 && this.latestWIPIndex >= this.allStepsData.length - 2) {
            const start = Math.max(0, this.allStepsData.length - 5);
            this.displayedSteps = this.allStepsData.slice(start);
            this.startIndex = start;
            this.startIndexNum = start;
        }
        else if (this.latestWIPIndex !== -1 && this.latestWIPIndex < 3) {
            this.displayedSteps = this.allStepsData.slice(0, 5);
        }
        else if (this.latestWIPIndex !== -1) {
            const start = Math.max(0, this.latestWIPIndex - 2);
            const end = Math.min(this.allStepsData.length, this.latestWIPIndex + 3);
            const topSteps = this.allStepsData.slice(start, this.latestWIPIndex);
            const bottomSteps = this.allStepsData.slice(this.latestWIPIndex + 1, end);
            this.displayedSteps = [...topSteps, this.allStepsData[this.latestWIPIndex], ...bottomSteps];
            this.startIndex = start;
            this.startIndexNum = start;
        }
        this.initialStepsData = this.displayedSteps;
        this.showAllSteps = false;
        this.showLegends = true;
        this.calculatePercentage();
    }

    viewPreviousSteps() {
        if (this.startIndex > 0) {
            this.startIndex = Math.max(0, this.startIndex - this.displayCount);
            this.updateDisplayedStep();
        }
    }

    viewNextSteps() {
        if (this.startIndex + this.displayCount < this.allStepsData.length) {
            this.startIndex = Math.min(this.allStepsData.length - this.displayCount, this.startIndex + this.displayCount);
            this.updateDisplayedStep();
        }
    }

    updateDisplayedStep() {
        // Calculate the end index for slicing the steps
        const endIndex = Math.min(this.startIndex + this.displayCount, this.allStepsData.length);
        this.displayedSteps = this.allStepsData.slice(this.startIndex, endIndex);
    }

    get shouldDisplayPreviousStepsLink(): boolean {
        return this.startIndex > 0;
    }

    get shouldDisplayNextStepsLink(): boolean {
        return this.startIndex + this.displayCount < this.allStepsData.length;
    }

    toggleViewAll() {
        this.showAllSteps = true;
        this.showInitialSteps = false;
    }

    returnToCurrentSteps() {
        this.displayedSteps = this.initialStepsData;
        this.showAllSteps = false;
        this.showInitialSteps = true;
        this.startIndex = this.startIndexNum;
    };

    addImageUrlsToData(data: TrackerStepsStatusViewModel[]): TrackerStepsStatusViewModel[] {
        return data.map(item => ({
            ...item,
            imageUrl: this.imageMapping[item.trackerSteps] || 'assets/images/default.png'
        }));
    };

    // estimate completion date based on number of working days
    lastWorkingDaysCalculator(startDate: Date, numberOfDays: number) {
        let count = 1,
            lastWorkingDay = new Date(startDate.toLocaleDateString());

        while (count < numberOfDays) {

            lastWorkingDay.setDate(lastWorkingDay.getDate() + 1);

            // including Saturday and Sunday as non working days
            if (lastWorkingDay.getDay() !== 0 && lastWorkingDay.getDay() !== 6 && !this.isHoliday(lastWorkingDay)) {
                count++;
            }
        }
        return lastWorkingDay;
    }

    isHoliday(date: Date) {
        return this.holidays.some(holiday => new Date(holiday.holidayDate).getTime() === new Date(date).getTime());
    }

    closeBanner() {
        this.isBannerVisible = false;
    }

    ngOnDestroy() {
        this.sessionSvc.GetShowBuilderHeader(false);
        this.contactUsData.reset();
        document.getElementById('glance-header-logo').hidden = false;
    }

    buildFeedbackFormGroup(): void {
        this.feedbackForm = new FormGroup({
            Id: new FormControl(null),
            BcaId: new FormControl(null),
            GrId: new FormControl(null),
            Rating: new FormControl(null),
            Feedback_Comment: new FormControl('', [Validators.required, Validators.maxLength(500)]),
        });
    }

    submitFeedback() {
        const formValue = this.feedbackForm.value;
        formValue.Id = this.feedbackIdGiven;
        formValue.BcaId = this.bcaId;
        formValue.GrId = this.id;
        formValue.Rating = this.rating;
        formValue.skippedAtStep = this.skippedStepGiven;
        formValue.Feedback_Comment = this.feedbackForm.controls['Feedback_Comment'].value;
        if (this.feedbackIdGiven != 0) {
            this.landingSvc.putFeedback(formValue).subscribe(result => {
            }, result => { swal(this.constantsSvc.errorSwal1, this.constantsSvc.contactCustomerCareSwal, this.constantsSvc.errorSwal); });
        }
        else {
            this.landingSvc.postFeedback(formValue).subscribe(result => {
            }, result => { swal(this.constantsSvc.errorSwal1, this.constantsSvc.contactCustomerCareSwal, this.constantsSvc.errorSwal); });
        }
        $('#feedback_modal').modal('hide');
    }

    skipFeedback() {
        const formValue = this.feedbackForm.value;
        formValue.Id = this.feedbackIdGiven;
        formValue.BcaId = this.bcaId;
        formValue.GrId = this.id;
        formValue.Rating = 0;
        formValue.skippedAtStep = this.stepSkippedAt;
        formValue.Feedback_Comment = null;
        if (this.feedbackIdGiven != 0) {
            this.landingSvc.putFeedback(formValue).subscribe(result => {
            }, result => { swal(this.constantsSvc.errorSwal1, this.constantsSvc.contactCustomerCareSwal, this.constantsSvc.errorSwal); });
        }
        else {
            this.landingSvc.postFeedback(formValue).subscribe(result => {
            }, result => { swal(this.constantsSvc.errorSwal1, this.constantsSvc.contactCustomerCareSwal, this.constantsSvc.errorSwal); });
        }
        $('#feedback_modal').modal('hide');
    }

    getFeedbackByProjectId(data: TrackerStepsStatusViewModel[]) {
        this.landingSvc.getFeedbackByProjectId(this.id).subscribe(result => {
            if (result.data != null) {
                this.feedbackAlreadyGiven = true;
                this.skippedStepGiven = result.data.skippedAtStep;
                this.feedbackIdGiven = result.data.id;
                this.feedbackTextGiven = result.data.feedback_Comment;
            }
            // Filter out completed steps count, if count is 5 or 7 then show the Feedback Popup if feedback is not already submitted
            const CompletedStepsListCount = data.filter(step => step.taskStatusCode === "C");

            if ((CompletedStepsListCount.length == 5 || CompletedStepsListCount.length == 7) &&
                (this.skippedStepGiven != CompletedStepsListCount.length) && this.skippedStepGiven != 7 &&
                (this.feedbackTextGiven == null || this.feedbackTextGiven == "")) {
                this.stepSkippedAt = CompletedStepsListCount.length;
                $('#feedback_modal').modal('show');
            }
        });
    }
    updateRating(rating: number): void {
        this.rating = rating;
    }
    createArray(n: number): any[] {
        return Array(n);
    }


    bindkmidata() {
        this.landingSvc.bindKMIDataByProjectId(this.id).subscribe(result => {
            if (result.data != null) {
                this.ExKMITransactionStatus = result.data.kmiCommunication;
                this.ExKMIEmail = result.data.kmiEmail;
                this.ExKMIPhone = result.data.kmiPhoneNo;
                this.ExKMIPrefrance = result.data.kmiPreference;
                this.ExKMIFrequency = result.data.kmiFrequency;
                this.kmiForm.setValue({
                    kmiCommunication: result.data.kmiCommunication,
                    kmiReceive: result.data.kmiPreference,
                    kmiEmailAddress: result.data.kmiEmail,
                    kmiTextNumber: result.data.kmiPhoneNo,
                    kmiFrequency: result.data.kmiFrequency

                });
            }
            setTimeout(this.disableTextAndBothOtions, 0);

        });
        
    }


    ClearKMIData() {
        this.setsearchControlNull(['KMISearchEmailAddress', 'KMISearchPhone']);
        this.kmiSearchForm.controls['KMISearchEmailAddress'].clearValidators();
        this.kmiSearchForm.controls['KMISearchPhone'].clearValidators();
        $('#KMI_Update_modal').modal('hide');
        this.filterProjectLength = 0;
        this.nodata = 0;
        this.blankdata = 0;
        //this.find = 0;
    }

    buildKMISearchFormGroup(): void {
        this.kmiSearchForm = new FormGroup({
            //KMIEmail: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.emailPattern)]),
            //KMIPhone: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)]),
            KMISearchEmailAddress: new FormControl('', { validators : [Validators.required, Validators.pattern(this.constantsSvc.emailPattern)], updateOn: 'blur' }),
            KMISearchPhone: new FormControl('', { validators : [Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)], updateOn: 'blur' })
        });
    }
    buildKMIFormGroup(): void {
        this.kmiForm = new FormGroup({
            kmiCommunication: new FormControl(null, [Validators.required]),
            kmiFrequency: new FormControl(null, [Validators.required]),
            kmiReceive: new FormControl(null, [Validators.required]),
            kmiEmailAddress: new FormControl(null, { validators: [Validators.required, Validators.pattern(this.constantsSvc.emailPattern)], updateOn: 'blur' }),
            kmiTextNumber: new FormControl('', { validators: [Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)], updateOn: 'blur' })
        });
        this.disableTextAndBothOtions();
    }
    

    getKMICintactByProjectId(data: TrackerStepsStatusViewModel[]) {      
            this.landingSvc.getKMIDataByProjectId(this.id).subscribe(result => {
                if (result.data != null) {
                    this.feedbackAlreadyGiven = true;
                }
                // Filter out completed steps count, if count is 5 or 7 then show the Feedback Popup if feedback is not already submitted
                const CompletedStepsListCount = data.filter(step => step.taskStatusCode === "C");
                if ((CompletedStepsListCount.length == 5 || CompletedStepsListCount.length == 7) && !this.feedbackAlreadyGiven) {
                    $('#KMI_modal').modal('show');
                }
            });
            this.disableTextAndBothOtions();
    }
    //KMI Communication Preference Update End
    //KMI Update
    //KMI Communication Preference Update Start
        redirectToKMIUpdate() {
            this.setsearchControlNull(['KMISearchEmailAddress', 'KMISearchPhone']);
        //this.kmiSearchForm.controls['KMIEmail'].clearValidators();
        //this.kmiSearchForm.controls['KMIPhone'].clearValidators();
        this.setControlNull(['kmiCommunication', 'kmiReceive', 'kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);
        this.filterProjectLength = 0;
            this.nodata = 0;
            this.blankdata = 0;
            this.buildKMISearchFormGroup();
        $('#KMI_Update_modal').modal('show');
    }

    onCommunicationCheck(control) {
        if (control.value == 'Yes' || control.value == 'No') {

            this.form.controls['kmiCommunication'].clearValidators();
        }

    }
    getControlValue(controlName: string) {
        return this.kmiForm.get(controlName).value;
    }
    setsearchControlNull(args: any[]) { args.forEach(arg => { this.kmiSearchForm.controls[arg].patchValue(null); }); }
    setControlNull(args: any[]) { args.forEach(arg => { this.kmiForm.controls[arg].patchValue(null); }); }
    clearValidators(args: any[]) {
        args.forEach(arg => {
            this.kmiForm.controls[arg].clearValidators();
            this.kmiForm.controls[arg].updateValueAndValidity();
        });
    }
    clearSearchValidators(args: any[]) {
        args.forEach(arg => {
            this.kmiSearchForm.controls[arg].clearValidators();
            this.kmiSearchForm.controls[arg].updateValueAndValidity();
        });
    }
    setRequiredValidator(args: any[]) {
        args.forEach(arg => {
            this.kmiForm.controls[arg].setValidators([Validators.required]);
            this.kmiForm.controls[arg].updateValueAndValidity();
        });
    }
    setRequiredSearchValidator(args: any[]) {
        args.forEach(arg => {
            this.kmiSearchForm.controls[arg].setValidators([Validators.required]);
            this.kmiSearchForm.controls[arg].updateValueAndValidity();
        });
    }
    setEmailCheckValidator(controlName: any) {
        this.kmiForm.controls[controlName].setValidators([Validators.required, Validators.pattern(this.constantsSvc.emailPattern)]);
        this.kmiForm.controls[controlName].updateValueAndValidity();
    }

    setSearchEmailCheckValidator(controlName: any) {
        this.kmiSearchForm.controls[controlName].setValidators([Validators.required, Validators.pattern(this.constantsSvc.emailPattern)]);
        this.kmiSearchForm.controls[controlName].updateValueAndValidity();
    }

    setPhoneCheckValidator(controlName: any) {
        this.kmiForm.controls[controlName].setValidators([Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)]);
        this.kmiForm.controls[controlName].updateValueAndValidity();
    }

    setSearchPhoneCheckValidator(controlName: any) {
     
        this.kmiSearchForm.controls[controlName].setValidators([Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)]);
        this.kmiSearchForm.controls[controlName].updateValueAndValidity();
    }

    onCommunicationCheck1(control) {
        if (control.value == 'Yes' || control.value == 'No') {
            this.kmiForm.controls['kmiCommunication'].clearValidators();
            this.kmiForm.controls['kmiCommunication'].updateValueAndValidity();
        }
        this.detectChange.detectChanges();
    }
    // used to put up questionary for user
    onQuestionCheck1(control) {
        
        switch (control.controlName) {
           
            case 'kmiCommunication':
                this.setControlNull(['kmiReceive', 'kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);
                this.clearValidators(['kmiReceive', 'kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);

                if (control.value === this.constantsSvc.Yes) {
                    this.setRequiredValidator(['kmiReceive', 'kmiFrequency']);
                    this.disableTextAndBothOtions();
                }

                else {
                    this.clearValidators(['kmiReceive', 'kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);
                }
                break;
            case 'kmiReceive':                
                this.setControlNull(['kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);
                this.clearValidators(['kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);
                if (control.value === 'Email') {
                    this.setEmailCheckValidator('kmiEmailAddress');
                    this.setRequiredValidator(['kmiFrequency']);
                }
                else if (control.value === 'Text') {
                    this.setPhoneCheckValidator('kmiTextNumber');
                    this.setRequiredValidator(['kmiFrequency']);
                }
                else if (control.value === 'Both') {
                    this.setEmailCheckValidator('kmiEmailAddress');
                    this.setPhoneCheckValidator('kmiTextNumber');
                    this.setRequiredValidator(['kmiFrequency']);
                }
            case 'kmiFrequency':               
                const formValue = this.kmiForm.value;
                if (formValue.kmiReceive === 'Email') {                    
                    this.setRequiredValidator(['kmiEmailAddress','kmiFrequency']);
                    this.setEmailCheckValidator('kmiEmailAddress');
                    this.clearValidators(['kmiTextNumber', 'kmiFrequency']);
                }
                else if (formValue.kmiReceive === 'Text') {                    
                    this.setRequiredValidator(['kmiTextNumber','kmiFrequency']);
                    this.setPhoneCheckValidator('kmiTextNumber');
                    this.clearValidators(['kmiEmailAddress', 'kmiFrequency']);
                }
                else if (formValue.kmiReceive === 'Both') {
                    this.setEmailCheckValidator('kmiEmailAddress');
                    this.setPhoneCheckValidator('kmiTextNumber');
                    this.setRequiredValidator(['kmiEmailAddress','kmiTextNumber','kmiFrequency']);
                    this.clearValidators(['kmiFrequency']);
                }
                break;

            default:
                return;
        }
    }

    detuctemailchange() {
        const formValue = this.kmiForm.value;
        if (formValue.kmiReceive != 'Both') {
            this.clearValidators(['kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);
        }
        else {
            this.clearValidators(['kmiEmailAddress', 'kmiFrequency']);
        }
        
        this.setEmailCheckValidator('kmiEmailAddress');
        this.setRequiredValidator(['kmiFrequency']);       
    }

    detuctPhonechange() {
        const formValue = this.kmiForm.value;
        if (formValue.kmiReceive != 'Both') {
            this.clearValidators(['kmiEmailAddress', 'kmiTextNumber', 'kmiFrequency']);
        }
        else {
            this.clearValidators(['kmiTextNumber', 'kmiFrequency']);
        }
       
        this.setPhoneCheckValidator('kmiTextNumber');
        this.setRequiredValidator(['kmiFrequency']);
        
    }

    detuctsearchemailchange() {
        this.filterProjectLength = 0;
        this.nodata = 0;
        this.blankdata = 0;
        const formValue = this.kmiSearchForm.value;
        if (formValue.KMISearchPhone != null && formValue.KMISearchPhone != '')
            this.setSearchPhoneCheckValidator('KMISearchPhone');
        else
            this.clearSearchValidators(['KMISearchPhone']);


        this.setSearchEmailCheckValidator('KMISearchEmailAddress');

    }

    detuctsearchphonechange() {
        this.filterProjectLength = 0;
        this.nodata = 0;
        this.blankdata = 0;
        const formValue = this.kmiSearchForm.value;

        if (formValue.KMISearchEmailAddress != null && formValue.KMISearchEmailAddress != '')
            this.setSearchEmailCheckValidator('KMISearchEmailAddress');
        else
            this.clearSearchValidators(['KMISearchEmailAddress']);



        this.setSearchPhoneCheckValidator('KMISearchPhone');

    }
    //KMI Communication Preference Update End

    contactUsRedirection() {
        this.contactUsData.reset();
        $('#service_tracker_contact_us_modal').modal('show');
    }

    onContactUsSubmit(contactUsData) {
        contactUsData.ApplicantId = this.id;
        contactUsData.BcaId = this.bcaId;
        this.contactUs.addContactUsDetails(contactUsData)
            .subscribe(() => {
                $('#service_tracker_contact_us_modal').modal('hide');
                $('#service_tracker_contact_us_confirmation_modal').modal('show');
            }, () => {
                $('#service_tracker_contact_us_modal').modal('hide');
            });
    }
    disableTextAndBothOtions() {
        // Get all radio buttons on the page
        const radioButtons = document.querySelectorAll('input[type="radio"]');

        // If you want to do something with each radio button, you can loop over them:
        radioButtons.forEach((radio: HTMLInputElement) => {
            if (radio) {
               
                if (radio.title === 'Both' || radio.title === 'Text') {
                    radio.disabled = true;
                }
            }
        });
    }

    getValidUrl(url: string): string {
        if (!url) {
            return null;
        }
        return url.startsWith('http://') || url.startsWith('https://') ? url : 'https://' + url;
    }

}
